import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Breadcrumbs,
  Button,
  Grid,
  Link,
  SvgIcon,
  Typography,
  makeStyles
} from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CircleIcon from '@mui/icons-material/Circle';
import { PlusCircle as PlusIcon } from 'react-feather';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { BookOpen as BookOpenIcon, Calendar as CalendarIcon,
  Box as RescourceIcon,
  Edit as EditIcon,

} from 'react-feather';
import { Stack } from '@mui/material';
const useStyles = makeStyles(() => ({
  root: {}
}));

const alignCenter={
  "display": "flex",
  "gap": "5px",
  "textDecoration": "none",
  "color": "inherit",
};
const Header = ({ className, ...rest }) => {
  const classes = useStyles();
  const {authData}=useSelector((state)=>state.authData);
  const {exam_slug}=useParams();
  const history=useHistory();
  const redirectUrl=(url)=>{
    history.push(url);
  }
  return (
    <Grid
      alignItems="center"
      container
      justify="space-between"
      spacing={3}
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Grid item>
        <Breadcrumbs
          // separator={<CircleIcon fontSize="small" />}
          separator={' '}
          aria-label="breadcrumb"
        >
          <a
            variant="body1"
            color="inherit"
            href='https://gsscore.com/Myaccount_free/knowledge_navigator'
            // to={`https://gsscore.com/Myaccount/knowledge_navigator`}
            style={alignCenter}

            >
            <BookOpenIcon/> ABL
          </a>
          <a
              variant="body1"
              color="inherit"
              href={`https://gsscore.com/Myaccount_free/student_planner`}
              style={alignCenter}
            >
            <CalendarIcon/> Study Scheduler
          </a>
          {/* <a
              variant="body1"
              color="inherit"
              href={`https://gsscore.com/60-days-planner`}
              style={alignCenter}
            >
            <RescourceIcon/> IAS PRELIMS 2024
          </a> */}
          {/* <a
              variant="body1"
              color="inherit"
              href={`https://gsscore.com/Myaccount/courseLandingPage`}
              style={alignCenter}
            >
            <EditIcon/> Modulearn
          </a> */}
        </Breadcrumbs>
        <Button
          style={{marginTop:"10px"}}          
          color="secondary"
          component={RouterLink}
          to={`/${exam_slug}/app/threads/create`}
          variant="contained"
          startIcon={
            <SvgIcon fontSize="small">
            <PlusIcon />
            </SvgIcon>
          }
        >
          Ask Questions
        </Button>
      </Grid>
      {authData.userId?
      <Grid item>        
        
      </Grid>
      :""
      }
      
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
